/*
 * Authors: mariushirjanu
 * Created: 21/03/2023
 */
import { Injectable } from '@angular/core';
import { BaseOrderEntryLocationToService } from '../base-order-entry-location-to.service';
import { OrderEntryLocationService } from '../order-entry-location.service';

@Injectable()
export class OrderEntryShippingService extends BaseOrderEntryLocationToService {
  constructor(
    orderEntryLocationService:OrderEntryLocationService
  ) {
    super(orderEntryLocationService);
  }
}